import React ,{Component } from 'react';
import MessageList from '../views/messagelist';
import { messageActions } from "../../actions";
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";

class MessageListContainer extends Component {
    constructor(props) {
        super(props);
        this.state={
            isInbox:true
        }
        this.getData = this.getData.bind(this);
        this.deleteData = this.deleteData.bind(this);
        
    }
    componentDidMount(){

        const {dispatch,match} = this.props;
        
        if(match.path=='/message/inbox')
        {
            console.log('inbox');
            this.setState({
                isInbox:true
            })
            dispatch(messageActions.gets(1,10,'','','','inbox=true'));

        }else if(match.path=='/message/outbox')
        {
            console.log('outbox');
            this.setState({
                isInbox:false
            })
            dispatch(messageActions.gets(1,10,'','','','inbox=false'));

        }
        
    }

    getData(page,perPage,sortField,sortOrder,filter)
    {
        const {dispatch} = this.props;
        dispatch(messageActions.gets(page,perPage,sortField,sortOrder,filter));
    }
    deleteData(id)
    {
        const {dispatch} = this.props;
        var result=window.confirm('آیا مطمئن هستید ؟');
        if(result)
        {
            dispatch(messageActions.delete(id,messageActions.gets(1,10,'','','')));
        }
    }
    
    render() { 

        const {list}=this.props;
        console.log('LIST',list);


        return ( 
           <MessageList isInbox={this.state.isInbox} deleteHandler={this.deleteData} remoteDataHandler={this.getData} list={list && list.Messages}></MessageList>
         );
    }
}

function mapStateToProps(state) {
    const { objs } = state;
    const { items } = objs;
    //const { queryable } = items;
    return {
        list:items,
        
           
        
    };
} 

export default withRouter(connect(mapStateToProps)(MessageListContainer));